export const website_name = process.env.REACT_APP_WEBSITE_NAME || 'Bharat Darshan';
export const access_token = process.env.REACT_APP_ACCESS_TOKEN || 'token';
export const refresh_token = process.env.REACT_APP_REFRESH_TOKEN || 'refreshToken';
export const userId = process.env.REACT_APP_USER_ID || 'userId';
export const login_time = process.env.REACT_APP_LOGIN_TIME || 'login_time';
export const api_urls_http = process.env.REACT_APP_API_URLS_HTTP || 'https://api.bharatdarshan.app/';
export const api_urls_https = process.env.REACT_APP_API_URLS_HTTPS || 'https://api.bharatdarshan.app/';
export const recharge_urls_https = process.env.REACT_APP_RECHARGE_URLS_HTTPS || 'https://api.bharatdarshan.app/';

export const web_urls_http = process.env.REACT_APP_WEB_URLS_HTTP || '';
export const web_urls_https = process.env.REACT_APP_WEB_URLS_HTTPS || '';
export const razorpay_live_key = process.env.REACT_APP_RAZORPAY_LIVE_KEY || '';
export const google_map_api_keys = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';